<template>
  <div class="footer">
      <div class="button" @click="$emit('clicked', true)">
        <span v-if="isLoading">Laden...</span>
        <div v-else-if="state === 'payment'" :class="fontclass">
          <span>{{ confirmText }} {{
            Number((amount / 100).toFixed(2))
              .toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' })
            }}
             met </span><img src="@/assets/logo-tikkie-800.png" />
        </div>
        <div v-else>
          <span>{{text}}</span>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'BottomButton',
  props: {
    state: String,
    amount: Number,
    text: String,
  },
  computed: {
    isLoading() {
      return this.$store.getters['application/getOrderLoading'];
    },
    fontclass() {
      if (this.amount > 999999) {
        return 'smallerfont';
      }
      return '';
    },
    confirmText() {
      if (this.$store.getters['application/getCampaign'].type === 'donation') {
        return 'Doneer';
      }
      return 'Betaal';
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/css/colors.scss';
#app {
  padding-bottom: 100px;
}
.footer {
  background-color: $white;
  height: 72px;
  width: 100%;
  position: fixed;
  bottom: 0;
  display: table;
  padding: 10px;
  box-sizing: border-box;
  .smallerfont {
    font-size: 14pt !important;
  }
  .button {
    width: 100%;
    display: table-cell;
    cursor: pointer;
    border-radius: 4px;
    height: 45px;
    background-color: $secondary;
    color: $white;
    padding: 0 10px 0 10px;
    margin: 8px;
    font-size: 18pt;
    text-align: center;
    vertical-align: middle;
    display: table-cell;
    span {
      vertical-align: middle;
    }
    img {
      max-height: 35px;
      vertical-align: middle;
    }
  }
}
</style>
